import React, { useState } from 'react';
import { 
  IconButton, 
  Badge, 
  Popover, 
  Box, 
  Typography, 
  Divider, 
  Button 
} from '@material-ui/core';
import NotificationsRoundedIcon from '@material-ui/icons/NotificationsRounded';
import { useNotifications } from 'services/providers/notification-provider';
import NotificationPanel from './notification-panel';

export default function NotificationBell({ color = "inherit" }) {
  const { unreadCount, markAllAsRead } = useNotifications();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'notification-popover' : undefined;

  return (
    <>
      <IconButton 
        color={color} 
        aria-describedby={id} 
        onClick={handleClick}
        style={{ padding: 12 }}
      >
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsRoundedIcon />
        </Badge>
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: { width: 350, maxHeight: 500 }
        }}
      >
        <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" style={{ fontWeight: 'bold' }}>
            Notifications
          </Typography>
          {unreadCount > 0 && (
            <Button size="small" color="primary" onClick={markAllAsRead}>
              Tout lire
            </Button>
          )}
        </Box>
        <Divider />
        <NotificationPanel onClose={handleClose} />
      </Popover>
    </>
  );
}
